import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { SpinnerService } from 'shared-components';
import { CultivosService } from '../../../services/cultivos.service';

@Component({
  selector: 'app-pro-denominaciones',
  templateUrl: './denominaciones.component.html'
})
export class ProductoresDenominacionesComponent implements OnInit {

  private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

  public listaPaisesDenominacion;

  public editables;
  public new = false;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 0; // La paginación en back empieza por 0, como los arrays.
  public totalItems: number;
  public readonly visiblePages = 3;

  @Input() productorId;

  @Output() refresh_ = new EventEmitter<boolean>();
  @Output() pushMessage = new EventEmitter<string>();

  constructor(
    private readonly _spinnerService: SpinnerService,
    private readonly _sessionContext: SessionContextService,
    private readonly _cultivosService: CultivosService) { }

  ngOnInit() {
    this.getDenominacionesProductor();
  }

  public get role() {
    return this._sessionContext.sessionUser.role;
  }

  public get claims() {
    return this._sessionContext.sessionUser.lsClaimTypes;
  }

  public pageChange(page) {
    this.currentPage = page - 1;
    this.getDenominacionesProductor();
  }

  public itemsPerPageChange(items) {
    this.currentPage = 0;
    this.itemsPerPage = items;
    this.getDenominacionesProductor();
  }

  public getDenominacionesProductor() {
    this._spinnerService.showSpinner();
    this._cultivosService.getDenominacionesProductor(this.productorId).toPromise().finally(() => {
      this._spinnerService.hideSpinner();
    }).then((resp) => {
      this.listaPaisesDenominacion = resp;
    });
  }

  public editableChanged(paisDenominacion) {
    this.editables = paisDenominacion;
    this.new = false;
  }

  public refresh(value) {
    this.editables = '';
    this.new = false;
    if (value) {
        this.reload();
        this.refresh_.emit(true);
    }
  }

  public reload() {
    this.getDenominacionesProductor();
  }

}
